// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
          meta: { src: '', view: 'HOME' },
        },
        {
          path: '/stabilimento.html',
          component: () => import('@/views/home/Index.vue'),
          meta: { src: '', view: 'HOME' },
        },
        {
          path: 'intervention-mode',
          name: 'Interventi',
          component: () => import('@/views/interventionMode/Index.vue'),
          meta: { src: require('@/assets/imgs/interventi.jpg') },
        },
        {
          path: 'eco-friendly',
          name: 'Eco-Friendly',
          component: () => import('@/views/ecoFriendly/Index.vue'),
          meta: { src: require('@/assets/imgs/eco-friendly.jpg') },
        },
        {
          path: 'safety',
          name: 'Sicurezza',
          component: () => import('@/views/safety/Index.vue'),
          meta: { src: require('@/assets/imgs/sicurezza.jpg') },
        },
        {
          path: '/public/privacy-policy.html',
          name: 'Privacy',
          component: () => import('@/views/privacy-policy/Index.vue'),
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },
  ],
})

export default router
